// Copyright 2022, Imprivata, Inc.  All rights reserved.

import type { TraceContext } from '@imprivata-cloud/common/types';
import {
  createSpanName,
  instrument,
  SpanComponent,
} from '@imprivata-cloud/common';
import type { WindowStyle } from '../../agent-api/types';
import type { MemorySection } from '.';
import { ShowWindowOption, WindowPositionFlag } from '../../agent-api/types';

export const createWindowSection = (memory: MemorySection) => {
  const showWindow2 = instrument(
    createSpanName(SpanComponent.SERVICE, 'show_window_2'),
    (
      _workflowId: string,
      _traceContext: TraceContext,
      showWindowOption: ShowWindowOption[],
    ): void => {
      memory.showWindowOption = showWindowOption[0];
      memory.onShowWindowChangeCallback?.(memory.showWindowOption);
    },
  );

  const setWindowPosition = instrument(
    createSpanName(SpanComponent.SERVICE, 'set_window_position'),
    (
      workflowId: string,
      traceContext: TraceContext,
      _x: number,
      _y: number,
      _width: number,
      _height: number,
      flags: WindowPositionFlag[],
    ): void => {
      if (flags.includes(WindowPositionFlag.show)) {
        showWindow2(workflowId, traceContext, [ShowWindowOption.show]);
      }
    },
  );

  const setWindowStyle = instrument(
    createSpanName(SpanComponent.SERVICE, 'set_window_style'),
    (
      _workflowId: string,
      _traceContext: TraceContext,
      windowStyle: WindowStyle[],
    ): void => {
      memory.setWindowStyle = windowStyle[0];
      memory.onSetWindowStyleChangeCallback?.(memory.setWindowStyle);
    },
  );

  return { showWindow2, setWindowPosition, setWindowStyle };
};

export type WindowSection = ReturnType<typeof createWindowSection>;
